export default __webpack_public_path__ + "static/course-items-3457550e369657fda033748cbc70f0e6.png";